var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvCompletedCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 9V11M9.25 9V11M11.25 9V11M15 10.5V9.5M7.4 13H11.1C11.9401 13 12.3601 13 12.681 12.8365C12.9632 12.6927 13.1927 12.4632 13.3365 12.181C13.5 11.8601 13.5 11.4401 13.5 10.6V9.4C13.5 8.55992 13.5 8.13988 13.3365 7.81901C13.1927 7.53677 12.9632 7.3073 12.681 7.16349C12.3601 7 11.9401 7 11.1 7H7.4C6.55992 7 6.13988 7 5.81901 7.16349C5.53677 7.3073 5.3073 7.53677 5.16349 7.81901C5 8.13988 5 8.55992 5 9.4V10.6C5 11.4401 5 11.8601 5.16349 12.181C5.3073 12.4632 5.53677 12.6927 5.81901 12.8365C6.13988 13 6.55992 13 7.4 13Z",
    stroke: "#667085",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvCompletedCharge);
export default __webpack_public_path__ + "static/media/evCompletedCharge.4fdfc2fdff6fe076746aa3ee2f07303f.svg";
export { ForwardRef as ReactComponent };